import React from 'react';
import Logo from '../Logo';
import SidebarNav from './SidebarNav';
import SidebarFooter from './SidebarFooter';

type SidebarProps = {
  className?: string;
};

const Sidebar: React.FC<SidebarProps> = ({ className }) => {
  return (
    <aside className={`${className} bg-white/90 backdrop-blur-xl border-r border-gray-200 shadow-lg shadow-gray-400/30 z-40 flex flex-col`}>
      <div className="h-16 flex items-center px-4 border-b border-gray-200/50">
        <Logo />
      </div>
      <SidebarNav />
      <SidebarFooter />
    </aside>
  );
};

export default Sidebar;